import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpWrapperService } from '.././http-wrapper.service';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { PagedResult } from '../../interfaces/IPagingResponseModel.interface';
import { IPagingRequestModel } from '../../interfaces/IPagingRequestModel.interface';
import { IActivityLog,IActivityLogStats } from '../../interfaces/activitylog.interface';
import { HttpHeaders } from '@angular/common/http';
import { IDictionary } from '../../interfaces/common.interfaces';


@Injectable({
  providedIn: 'root',
})
export class ActivityLogService {
  constructor(private httpWrapperService: HttpWrapperService) {}

  getActivityLogs(
    communityId: number,
    request: IPagingRequestModel,
    campaignId?: number
  ): Observable<PagedResult<IActivityLog>> {
    let url = `activitylog/${communityId}`;
    if (campaignId) {
      url = `${url}?campaignId=${campaignId}`;
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params: { [key: string]: string } = {};

    // If campaignId is provided, include it in the query parameters
    if (campaignId !== undefined && campaignId !== null) {
      params['campaignId'] = campaignId.toString();
    }

    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: request,
      params: params,
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: PagedResult<IActivityLog>) => response));
  }

  getDataForFilters(
    communityId: number,
    request: IPagingRequestModel,
    campaignId?: number
  ): Observable<IDictionary<string, string[]>> {
    let url = `ActivityFilter/${communityId}`;
    if (campaignId) {
      url = `${url}?campaignId=${campaignId}`;
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params: { [key: string]: string } = {};

    // If campaignId is provided, include it in the query parameters
    if (campaignId !== undefined && campaignId !== null) {
      params['campaignId'] = campaignId.toString();
    }

    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: request,
      params: params,
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: IDictionary<string, string[]>) => response));
  }
  exportFilteredDataToCsv(
    communityId: number,
    request: any,
    campaignId?: number
  ): Observable<Blob> {
    let url = `activitylog/export/${communityId}`;
    if (campaignId) {
      url = `${url}?campaignId=${campaignId}`;
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params: { [key: string]: string } = {};

    // If campaignId is provided, include it in the query parameters
    if (campaignId !== undefined && campaignId !== null) {
      params['campaignId'] = campaignId.toString();
    }

    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: request,
      params: params,
      responseType: 'blob',
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: Blob) => response));
  }

  updateActivityLog(activityLog: IActivityLog): Observable<any> {
    const url = `activitylog/update/${activityLog.activityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const activityLogPayload = this.mapToStaticDataPayload(activityLog);
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: activityLogPayload,
    };

    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: any) => response));
  }

  deleteActivityLog(activityId: number): Observable<any> {
    const url = `activitylog/${activityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
    };

    return this.httpWrapperService
      .deleteFromApiGateWay(options)
      .pipe(map((response: any) => response));
  }

  private mapToStaticDataPayload(record: IActivityLog): any {
    return {
      firstName: record.firstName,
      lastName: record.lastName,
      email: record.email,
      phone: record.phone,
      organizationBusinessName: record.organizationBusinessName,
      comments: record.comments,
      documents: record.documentBlobUrl,
      volunteerHoursWorked: record.volunteerHoursWorked,
      isVolunteerPresent: record.isVolunteerPresent,
    };
  }
  getActivityLogDashboard(
    communityId: number,
    campaignId?: number
  ): Observable<IActivityLogStats> {
    let url = `ActivityLog/dashboard/${communityId}`;
    if (campaignId !== undefined && campaignId !== null) {
      url = `${url}?campaignId=${campaignId}`;
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params: { [key: string]: string } = {};
    if (campaignId !== undefined && campaignId !== null) {
      params['campaignId'] = campaignId.toString();
    }
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: {}, 
      params: params,
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: any) => response));
  }
}